import * as env from "@resn/gozer-env"

export const useResize2 = (fn) => {
  // const env = useEnv()
  return useResize(() => {
    if (!import.meta.client) return
    if (env.isMobile) return
    fn()
  })
}
